import Loadable, { NullLoader } from '@comeon/loadable';
import { useSelector } from 'react-redux';
import { LICENSE_DEGA, LICENSE_KSA } from '~/utils/license-utils.js';
import { selectLicense, selectRCWebSocket } from '~/components/brand/ducks/selectors.js';

const RealityCheck = Loadable({
	loader: () => import('./reality-check.js'),
	loading: NullLoader
});

const RealityCheckGerman = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "dega-bundle" */
			'./reality-check-german.js'
		),
	loading: NullLoader
});

const RealityCheckWebSocket = Loadable({
	loader: () => import('./reality-check-websocket.js'),
	loading: NullLoader
});

const RealityCheckNetherlands = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "ksa-bundle" */
			'./reality-check-netherlands.tsx'
		),
	loading: NullLoader
});

const REALITY_CHECK_IMPL = {
	[LICENSE_DEGA]: RealityCheckGerman,
	[LICENSE_KSA]: RealityCheckNetherlands
};

const RealityCheckContainer = () => {
	const license = useSelector(selectLicense);
	const enableRCWebSocket = useSelector(selectRCWebSocket);
	const Component = enableRCWebSocket ? RealityCheckWebSocket : REALITY_CHECK_IMPL[license] ?? RealityCheck;
	return <Component />;
};

export default RealityCheckContainer;
